import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.input.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
    },
    header: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: spacing.xs,
      width: "100%",
      background: "none",
      border: "none",
      padding: 0,
      cursor: "pointer",
      textAlign: "left",
    },
    title: {
      flex: 1,
    },
    chevronWrap: {
      display: "flex",
      transition: "transform 0.25s ease",
    },
    chevronOpen: {
      transform: "rotate(180deg)",
    },
    expandGrid: {
      display: "grid",
      transition: "grid-template-rows 0.25s ease",
    },
    expandGridOpen: {
      gridTemplateRows: "1fr",
    },
    expandGridClosed: {
      gridTemplateRows: "0fr",
    },
    expandInner: {
      overflow: "hidden",
    },
  };

  return styles;
};
